module.exports = __webpack_public_path__ + "img/Eduzz-8-en.59d8533d.png";